document.addEventListener('DOMContentLoaded', function () {
  const currentHost = window.location.hostname;
  const links = document.querySelectorAll('a[href^="http"]');

  links.forEach(function (link) {
    try {
      const linkHost = new URL(link.href).hostname;
      if (linkHost !== currentHost) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (e) {
      // Ignore malformed hrefs
    }
  });
});